export { default } from './ToggleButton';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/ToggleButton/index.js
// module id = 901
// module chunks = 2